import { render, staticRenderFns } from "./DeiceAlarmRecord.vue?vue&type=template&id=1c7debbc&scoped=true&"
import script from "./DeiceAlarmRecord.vue?vue&type=script&lang=js&"
export * from "./DeiceAlarmRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7debbc",
  null
  
)

export default component.exports